import React from "react";

import { noWrap, Stack, Text } from "@bps/fluent-ui";
import { IdentityIcon } from "@components/IdentityIcon";
import { TabsNavLinkProps } from "@components/tabs-nav/TabNav.types";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";

export const FieldTabLink: React.FC<TabsNavLinkProps<FieldDevice>> = ({
  details
}) => {
  return (
    <Stack
      horizontal
      styles={{
        root: {
          minWidth: "200px"
        }
      }}
    >
      <IdentityIcon id={details.id} size={30} />
      <Stack.Item
        styles={{
          root: { alignContent: "center" }
        }}
      >
        <Stack
          styles={{
            root: {
              lineHeight: "1rem",
              textAlign: "left",
              marginLeft: "4px",
              ...noWrap
            }
          }}
        >
          <Text variant="small" bold nowrap>
            {details.name}
          </Text>
          <Text variant="xSmall" nowrap>
            {details.id}
          </Text>
        </Stack>
      </Stack.Item>
    </Stack>
  );
};
